/* ----------------------------------------------------------------------------
clamp long content
---------------------------------------------------------------------------- */

export default class ClampContent extends HTMLElement {
  static get observedAttributes() {
    return ["label"]
  }

  get label() {
    return this.hasAttribute("label") ? this.getAttribute("label") : "Expand"
  }

  clamp(element) {
    if (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth) {
      const template = `
        <div class="overlay">
          <button class="sh-btn sh-btn-text-muted sh-btn-sm sh-btn-outline">${this.label}</button>
        </div>
      `
      element.insertAdjacentHTML("afterend", template)
      const overlay = this.querySelector(":scope > .overlay")
      const button = this.querySelector(":scope > .overlay button")
      overlay.classList.add("--show")
      button.addEventListener("click", () => {
        this.classList.add("--disabled")
        overlay.remove()
      })
    } else {
      this.classList.add("--disabled")
    }
  }

  connectedCallback() {
    this.target = this.querySelector(":scope > *")
    this.clamp(this.target)
  }
}

window.customElements.define("clamp-content", ClampContent)
